const doc = [({"zh_cn":({"adminConstantBedType":({"bed":"床", "futon":"日式被褥", "sofaBed":"沙发床"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;